import type { DOCUMENT_TYPES } from "../api/rest/account";

/**
 * Maps canonical doc type values to their legacy equivalents.
 * During the w8ben rename transition, the backend may return either
 * "w8ben" (new canonical) or "w_8ben" (legacy). This normalizer ensures
 * the frontend can handle both until the migration is complete.
 */
const docTypeAliases: Record<string, (typeof DOCUMENT_TYPES)[number]> = {
  w8ben: "w_8ben",
  w8bene: "w_8bene",
};

export const normalizeDocType = (
  docType: string,
): (typeof DOCUMENT_TYPES)[number] => docTypeAliases[docType] ?? docType;
